import { MaterialIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { Box, Button, Divider, HStack, Icon, Text, VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";

import BadgeList, { BadgeType } from "@/components/molecules/BadgeList";
import HeaderAccountButton from "@/components/molecules/HeaderAccountButton";
import HeaderAddressButton from "@/components/molecules/HeaderAddressButton";
import HearderCartButton from "@/components/molecules/HearderCartButton";
import WebSearchDropdown from "@/components/molecules/WebSearchDropdown";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

type WebHeaderType<T> = {
  title: string;
  badgeTitle?: string;
  badgeList?: T[];
  activeBadgeId?: string;
  searchInStoreId?: string;
  disableBuiltInSearch?: boolean;
  onPressBack: () => void;
  onSelectBadge?: (item: T) => void;
  onChangeSearch?: (text: string) => void;
};

const WebHeader = <T extends BadgeType>({
  title,
  badgeTitle,
  badgeList,
  activeBadgeId,
  searchInStoreId,
  disableBuiltInSearch,
  onPressBack,
  onSelectBadge,
  onChangeSearch,
}: WebHeaderType<T>) => {
  return (
    <VStack
      safeAreaTop
      w="full"
      position="sticky"
      top={0}
      bgColor="white.50"
      px="10"
      py="4"
      shadow="6"
      zIndex={9999}>
      <HStack w="full" justifyContent="space-between" alignItems="center">
        <HStack w="1/4">
          <Button variant="ghost" onPress={() => onPressBack()}>
            <Icon as={<MaterialIcons name="arrow-back-ios" />} size="xl" color="primary.600" />
          </Button>
          {!title ? (
            <Box mx="4" alignItems="center">
              <ShimmerPlaceholder height="36px" />
            </Box>
          ) : (
            <Text fontSize="3xl" color="primary.600" mx="4" bold isTruncated>
              {title}
            </Text>
          )}
        </HStack>
        <WebSearchDropdown
          storeId={searchInStoreId}
          disableBuiltInSearch={disableBuiltInSearch}
          onChangeSearch={onChangeSearch}
        />
        <HStack>
          <HeaderAddressButton borderRadius={10} />
          <HearderCartButton />
          <HeaderAccountButton />
        </HStack>
      </HStack>
      {badgeList && (
        <HStack w="full" pt="4" justifyContent="space-between" alignItems="center" zIndex={-1}>
          <Text fontSize="lg" color="text.600">
            {badgeTitle}
          </Text>
          <Divider orientation="vertical" mx="3" />
          <BadgeList list={badgeList} activeId={activeBadgeId} onSelect={onSelectBadge} />
        </HStack>
      )}
    </VStack>
  );
};

export default WebHeader;
